import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function get() {
      try {
            const response = await callGetApi({ url: "configuration" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function update(data) {
      try {
            const response = await callPutApi({ url: "configuration", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}


export async function getByConfigurationKey(key) {
      try {
            const response = await callGetApi({ url: "configuration/key/" + key });
            return response;
      } catch (error) {
            throw error;
      }
}


export async function getExceptions() {
      try {
            const response = await callGetApi({ url: "exception-master" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function addExceptions(data) {
      try {
            const response = await callPostApi({ url: "exception-master", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateExceptions(data) {
      try {
            const response = await callPutApi({ url: "exception-master", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteExceptions(id) {
      try {
            const response = await callDeleteApi({ url: "exception-master/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getPayrollDates() {
      try {
            const response = await callGetApi({ url: "payroll-date" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function addPayrollDates(data) {
      try {
            const response = await callPostApi({ url: "payroll-date", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updatePayrollDates(data) {
      try {
            const response = await callPutApi({ url: "payroll-date", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function handleDeletePayrollDateData(id) {
      try {
            const response = await callDeleteApi({ url: "payroll-date/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

// Email Notification setting
export async function getEmailNotificationList(data) {
      try {
            const response = await callPostApi({ url: "store-settings/email-notification/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function emailNotificationAdd(data) {
      try {
            const response = await callPostApi({ url: "store-settings/email-notification/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function emailNotificationUpdate(data) {
      try {
            const response = await callPutApi({ url: "store-settings/email-notification/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function emailNotificationGetById(id) {
      try {
            const response = await callGetApi({ url: "store-settings/email-notification/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function emailNotificationDeleteById(id) {
      try {
            const response = await callDeleteApi({ url: "store-settings/email-notification/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

// Rollover time setting
export async function getRolloverTimeInfo() {
      try {
            const response = await callGetApi({ url: "store-settings/rollover-time/" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function rolloverTimeUpdate(data) {
      try {
            const response = await callPutApi({ url: "store-settings/rollover-time/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

// Upcharge Dates setting
export async function getUpchargeDatesList(data) {
      try {
            const response = await callPostApi({ url: "store-settings/upcharge-date/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function upchargeDatesAdd(data) {
      try {
            const response = await callPostApi({ url: "store-settings/upcharge-date/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function upchargeDatesUpdate(data) {
      try {
            const response = await callPutApi({ url: "store-settings/upcharge-date/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function upchargeDatesGetById(id) {
      try {
            const response = await callGetApi({ url: "store-settings/upcharge-date/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function upchargeDatesDeleteById(id) {
      try {
            const response = await callDeleteApi({ url: "store-settings/upcharge-date/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getFolderGroups(data) {
      try {
            const response = await callGetApi({ url: "store-settings/folder/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getFolderNormalList() {
      try {
            const response = await callGetApi({ url: "store-settings/folder/normal-list" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function groupZipcodeAdd(data) {
      try {
            const response = await callPostApi({ url: "store-settings/folder/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function groupZipcodeUpdate(data) {
      try {
            const response = await callPutApi({ url: "store-settings/folder/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function groupZipcodeGetById(id) {
      try {
            const response = await callGetApi({ url: "store-settings/folder/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function groupZipcodeDeleteById(id) {
      try {
            const response = await callDeleteApi({ url: "store-settings/folder/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function zipcodeListByGroup(data, id) {
      try {
            const response = await callPostApi({ url: "store-settings/zipcode/list/group/" + id, body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function zipcodeAdd(data) {
      try {
            const response = await callPostApi({ url: "store-settings/zipcode/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function zipcodeUpdate(data) {
      try {
            const response = await callPutApi({ url: "store-settings/zipcode/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function zipcodeGetById(id) {
      try {
            const response = await callGetApi({ url: "store-settings/zipcode/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function zipcodeDeleteById(id) {
      try {
            const response = await callDeleteApi({ url: "store-settings/zipcode/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

// Designer setting
export async function getDesignerSettings() {
      try {
            const response = await callGetApi({ url: "store-designer-settings" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateDesignerSettings(data) {
      try {
            const response = await callPutApi({ url: "store-designer-settings/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}